<template lang="html">

  <section class="error-404">
    <h1>error-404 Component</h1>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'error-404',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped >
  .error-404 {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/error-404.vue